module.exports = "<div id=\"mobie-dtcr\">\n  <!-- <div class=\"modal-header\">\n    <h4 class=\"modal-title\">Important</h4>\n  </div> -->\n  <div class=\"modal-body\">\n    <p> Sorry for the inconvenience.<br> Please access the web panel from the laptop or desktop </p>\n  </div>\n  <div class=\"modal-footer\">\n    <button [routerLink]=\"['/deviceDetector']\" type=\"button\" class=\"save-btn btn btn-default\">Okay</button>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/device-detector/device-detector.component.html
// module id = ./src/app/device-detector/device-detector.component.html
// module chunks = main